export default __webpack_public_path__ + "static/media/backarrow.423a5192.svg";